const { __ } = wp.i18n;

/**
 * Counts down every second until target date is reached
 *
 * @param {string} date Date in format "Month Day, Year HH:MM:SS"
 */
const countdown = ( date ) => {

	const targetDate = new Date( date ).getTime();

	const countdownInterval = setInterval( () => {

		const currentDate = new Date().getTime();
		const timeRemaining = targetDate - currentDate;

		const days = Math.floor( timeRemaining / (1000 * 60 * 60 * 24) );
		const hours = Math.floor( (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60) );
		const minutes = Math.floor( (timeRemaining % (1000 * 60 * 60)) / (1000 * 60) );
		const seconds = Math.floor( (timeRemaining % (1000 * 60)) / 1000 );

		if ( document.getElementById( 'countdown' ) ) {
			document.getElementById( 'countdown' ).innerHTML = `
            <div><span class="countdown__num">${days > 0 ? days : '0'}</span> <span class="countdown__label">${__( 'dni', 'pik' )}</span></div>
            <div><span class="countdown__num">${hours > 0 ? hours : '0'}</span> <span class="countdown__label">${__( 'godzin', 'pik' )}</span></div>
            <div><span class="countdown__num">${minutes > 0 ? minutes : '0'}</span> <span class="countdown__label">${__( 'minut', 'pik' )}</span></div>
            <div><span class="countdown__num">${seconds > 0 ? seconds : '0'}</span> <span class="countdown__label">${__( 'sekund', 'pik' )}</span></div>
        `;

			if ( timeRemaining < 1000 ) {
				clearInterval( countdownInterval );
			}
		}
	}, 1000 );

}

window.addEventListener( 'DOMContentLoaded', () => {
	countdown( pikCountdownData.eventDate );
} )
